const testimonials = [
  {
    name: 'Marcus Rivera',
    role: 'CEO, Rivera & Associates Law Firm',
    quote: 'Brito Consulting made our small business feel like we had a Fortune 500 IT department. Response times are incredible and they actually understand our business.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20latino%20businessman%20in%20his%2040s%20wearing%20a%20suit%20with%20a%20clean%20white%20background&width=120&height=120&seq=avatar-1&orientation=squarish',
    stars: 5,
  },
  {
    name: 'Sandra Chen',
    role: 'Operations Director, MedFirst Clinic',
    quote: 'After switching to Brito Consulting, our downtime dropped to nearly zero. Their proactive monitoring caught issues before we even knew they existed.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20asian%20businesswoman%20in%20her%2030s%20smiling%20confidently%20with%20a%20clean%20neutral%20background&width=120&height=120&seq=avatar-2&orientation=squarish',
    stars: 5,
  },
  {
    name: 'James Whitfield',
    role: 'Owner, Whitfield Construction',
    quote: 'The team at BCG set up our entire cloud infrastructure in under a week. We went from constant IT headaches to smooth sailing overnight.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20caucasian%20businessman%20in%20his%2050s%20with%20a%20friendly%20smile%20and%20clean%20background&width=120&height=120&seq=avatar-3&orientation=squarish',
    stars: 5,
  },
];

export default function TestimonialSection() {
  return null;
}
